import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    constructor() {
        super();
        this.setState({
            isOpen: false,
        });
    }

    render({ i }) {
        return (
            <tarot-reading-sample-interp-item class='interp-item'>
                {this.renderInterp(i)}
            </tarot-reading-sample-interp-item>
        );
    }

    renderInterp = (i) => {
        if (this.props.sample_interps[i]) {
            return (
                <div class='interp-accordion' onClick={this.toggle}>
                    <div class='flow-root' data-action={'Click-' + this.props.teeup.positions[i].title + '-Interp'}>
                        <img
                          class='interp-thumb left'
                          src={this.props.deck.cards[this.props.picked_cards[i]].images.table}
                          alt={this.props.deck.cards[this.props.picked_cards[i]].name}
                        />
                        <h1>{this.props.sample_interps[i].position_name}</h1>
                        <h2>{this.props.deck.cards[this.props.picked_cards[i]].name}</h2>
                    </div>
                    {this.renderInterpContent(i)}
                </div>
            );
        }

        return (
            <div class='position-description'>
                <div class='flow-root'>
                    <img
                      src='https://gfx.tarot.com/images/site/tarot/free-tarot-reading/question-grey.svg'
                      class='position-thumb left'
                    />
                    <div>
                        <h2>{this.props.teeup.positions[i].title }</h2>
                        <p>{this.props.teeup.positions[i].seo_description }</p>
                    </div>
                </div>
            </div>
        );
    }

    renderInterpContent = (i) => {
        if (this.state.isOpen) {
            return (
                <div class='flow-root'>
                    <img
                      class='interp-card left'
                      src={this.props.deck.cards[this.props.picked_cards[i]].images.full}
                      alt={this.props.deck.cards[this.props.picked_cards[i]].name}
                    />
                    <h3>{this.props.sample_interps[i].interp_header }</h3>
                    <p
                      class='interp-description'
                      dangerouslySetInnerHTML={{__html: this.props.sample_interps[i].interp}}
                    />
                </div>
            );
        }

        return null;
    }

    toggle = () => {
        this.setState({ isOpen: !this.state.isOpen });
    }
}

const mapStateToProps = (state) => ({
    sample_interps: state['tarot-reading'].interps,
    teeup: state.product.teeup,
    deck: state.deck,
    picked_cards: state['tarot-reading'].cards,
});

export default connect(mapStateToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/tarot-readings/tarot-reading/sample-interp-item.js